import React from "react";
import cn from "classnames";
import styles from "./Program.module.sass";
import { Link } from "react-router-dom";

const FonctionnalitesContrat = () => {
  return (
    <div className={cn("section-bg", styles.book)}>
      {/* Conteneur d'image qui s'étend sur le côté droit de l'écran */}
      <div className={styles.imageContainer}>
        <img
          src="/images/content/image-58.png"
          alt="Interface de gestion des absences"
          className={styles.mainImage}
        />
      </div>
      <div className={cn("section-bg", styles.section)}>
        <div className={cn("container", styles.container)}>
          {/* Left side - Text content */}
          <div className={styles.textContent}>
            <h2 className={styles.title}>
              Simplifiez vos audits Qualiopi
            </h2>
            <div className={styles.features}>
              <div className={styles.feature}>
                <div className={styles.checkIcon}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#39CD54" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <span><strong>Rapports automatiques</strong> - Générez instantanément tous les rapports d'assiduité et de satisfaction requis pour Qualiopi.</span>
              </div>
              <div className={styles.feature}>
                <div className={styles.checkIcon}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#39CD54" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <span><strong>Données certifiées</strong> - Toutes vos données sont horodatées et certifiées, garantissant leur validité lors des audits.</span>
              </div>
              <div className={styles.feature}>
                <div className={styles.checkIcon}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#39CD54" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <span><strong>Suivi des élèves à risque</strong> - Identifiez automatiquement les apprenants en difficulté pour prévenir les ruptures de contrat.</span>
              </div>
              <div className={styles.feature}>
                <div className={styles.checkIcon}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#39CD54" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <span><strong>Preuves de conformité</strong> - Conservez automatiquement toutes les preuves nécessaires pour démontrer votre conformité Qualiopi.</span>
              </div>
            </div>
            <div className={styles.cta}>
              <Link className={cn("button", styles.button)} to="/contact">
                Profiter d'un essai gratuit
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FonctionnalitesContrat;
